import React__default from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import { isModifiedClickEvent } from '@grandvisionhq/utils';
import { updateActiveVariant } from '../../../context/actions.js';
import { ProductAnalyticsEvents } from '../../Analytics/events/ProductAnalyticsEvents.js';
import { FacetPickerOther } from '../components/FacetPickers/FacetPickerOther/FacetPickerOther.js';
import { useProductDetailSlots } from '../../../slots/context.js';
import { getFacetPickerConfig } from '../utils/get-facet-picker-config.js';
import { NonRxProductCTA } from '../components/NonRxProductCTA/NonRxProductCTA.js';
import { Tags } from '../components/Tags/Tags.js';
import { PriceSection } from '../components/PriceSection/PriceSection.js';
import { StarRatingReview } from '../../Reviews/StarRatingReview.js';
import { ProductStockIndicator } from '../components/StockIndicator/ProductStockIndicator.js';
import { useProductData } from '../../../context/ProductContext.js';

const AccessoriesEcommContent = ({ className , showOnlyCTA , ctaRef  })=>{
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { activeVariant: { displayName , sku: activeSku , stock , channelAvailability , isExcludedFromCheckout ,  } , product , dispatch , routes ,  } = useProductData();
    const { facetTree , productType  } = product;
    const { Slots  } = useProductDetailSlots();
    const { activeParentFacet: activeFacet , otherFacets: otherfacets , colorFacets: colorFacets , showParentFacetPicker: showFacets ,  } = getFacetPickerConfig(facetTree, activeSku);
    const accessoriesFacets = [
        ...otherfacets,
        ...colorFacets
    ];
    const handleConversionEvent = React__default.useCallback(()=>{
    // @TODO: handle conversion event in #
    // Possibly we will need to add this to products-details-v2
    }, []);
    const handleVariantSelection = React__default.useCallback(({ event , sku , href  })=>{
        // Allow customers to open another variant in a new tab or window, otherwise prevent navigation
        if (!event || !isModifiedClickEvent(event)) {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            dispatch(updateActiveVariant({
                sku
            }));
            window.history.replaceState(null, '', href);
        }
    }, [
        dispatch
    ]);
    const handleFacetSelection = (props)=>{
        const { name , sku , facetTerm  } = props;
        ProductAnalyticsEvents.pushPdpVariantClickEvent({
            type: productType,
            name,
            id: sku,
            dimension147: facetTerm
        });
        handleVariantSelection(props);
    };
    const onAddToCartSuccess = React__default.useCallback(()=>{
    // @TODO: in a future story, this is where the data analytics will be triggered
    }, []);
    const CTAButton = /*#__PURE__*/ React__default.createElement(NonRxProductCTA, {
        storesRoute: routes.stores,
        action: channelAvailability === 'ONLINE' ? 'ADD_TO_CART' : 'ADD_TO_CART_UNAVAILABLE',
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: {
            activeSku,
            onSuccess: onAddToCartSuccess
        }
    });
    if (showOnlyCTA) {
        return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, CTAButton);
    }
    return /*#__PURE__*/ React__default.createElement("section", {
        "aria-label": displayName,
        className: classnames('accessories-ecomm-content', className)
    }, /*#__PURE__*/ React__default.createElement(Tags, null), /*#__PURE__*/ React__default.createElement("div", {
        className: "accessories-ecomm-content__section"
    }, /*#__PURE__*/ React__default.createElement(PriceSection, null), !isMobile && /*#__PURE__*/ React__default.createElement(StarRatingReview, {
        className: "sunglasses-ecomm-content__star-review"
    })), !showFacets && /*#__PURE__*/ React__default.createElement("div", {
        className: "sunglasses-ecomm-content__single-facet-term sunglasses-ecomm-content__section"
    }, activeFacet && /*#__PURE__*/ React__default.createElement("div", null, activeFacet.facetTerm), /*#__PURE__*/ React__default.createElement(ProductStockIndicator, null)), accessoriesFacets && showFacets && /*#__PURE__*/ React__default.createElement(FacetPickerOther, {
        className: "sunglasses-ecomm-content__section",
        productType: productType,
        activeFacet: activeFacet,
        onPick: handleFacetSelection,
        items: accessoriesFacets,
        enableStockIndicator: stock.enableStockIndicator
    }), Slots.DynamicDeliveryIndicator ? /*#__PURE__*/ React__default.createElement(Slots.DynamicDeliveryIndicator, {
        isExcludedFromCheckout: isExcludedFromCheckout,
        deliveryItems: [
            {
                sku: activeSku,
                quantity: 1
            }
        ]
    }) : null, /*#__PURE__*/ React__default.createElement("div", {
        ref: ctaRef
    }, CTAButton), Slots.AfterCTA ? /*#__PURE__*/ React__default.createElement(Slots.AfterCTA, null) : null);
};

export { AccessoriesEcommContent };
//# sourceMappingURL=AccessoriesEcommContent.js.map
